// extracted by mini-css-extract-plugin
export var fadeGrow = "styles-module--fadeGrow--3692c";
export var fadeUp = "styles-module--fadeUp--c0810";
export var visible = "styles-module--visible--1d5e5";